import React from 'react';

function MainLayout({ children }) {
  return (
    <div className="main-layout">
        {children}
    </div>
  );
}

export default MainLayout;